import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import ResourcePage from "@/components/ResourcePage";
import { Badge } from "@/components/Common";

export default function FuelLogs() {
  const [vehicles, setVehicles] = useState([]);
  useEffect(() => { api.get("/vehicles").then(({ data }) => setVehicles(data)); }, []);
  const vMap = Object.fromEntries(vehicles.map((v) => [v.id, v.plate_number]));
  return (
    <ResourcePage
      endpoint="/fuel-logs"
      testidPrefix="fuel"
      eyebrow="Operations"
      title="Fuel Logs"
      subtitle="Track fleet fuel consumption and costs."
      ctaLabel="Log fuel"
      fields={[
        { name: "vehicle_id", label: "Vehicle", type: "select", required: true,
          options: vehicles.map((v) => ({ value: v.id, label: `${v.plate_number} · ${v.make || ""} ${v.model || ""}`.trim() })) },
        { name: "date", label: "Date", type: "date" },
        { name: "litres", label: "Litres", type: "number" },
        { name: "cost", label: "Cost (UGX)", type: "number" },
        { name: "odometer", label: "Odometer (km)", type: "number" },
        { name: "station", label: "Station" },
        { name: "notes", label: "Notes", type: "textarea" },
      ]}
      columns={[
        { key: "vehicle_id", label: "Vehicle", render: (i) => <Badge tone="slate">{vMap[i.vehicle_id] || "—"}</Badge> },
        { key: "date", label: "Date" },
        { key: "litres", label: "Litres" },
        { key: "cost", label: "Cost", render: (i) => i.cost ? `UGX ${Number(i.cost).toLocaleString()}` : "—" },
        { key: "odometer", label: "Odo (km)" },
        { key: "station", label: "Station" },
      ]}
      searchKeys={["station", "notes"]}
    />
  );
}
